var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlessedSeeker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62561 35.0004C7.73725 33.2912 9.25818 31.8867 11.0503 30.9144C12.8425 29.9422 14.8491 29.4329 16.888 29.4329C18.9269 29.4329 20.9335 29.9422 22.7257 30.9144C24.5178 31.8867 26.0387 33.2912 27.1504 35.0004",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8871 26.4678C20.1652 26.4678 22.8226 23.2291 22.8226 19.2339C22.8226 15.2387 20.1652 12 16.8871 12C13.609 12 10.9516 15.2387 10.9516 19.2339C10.9516 23.2291 13.609 26.4678 16.8871 26.4678Z",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4755 11.1422L31.8369 15.6488C31.7986 15.7519 31.7297 15.8408 31.6395 15.9036C31.5492 15.9664 31.4419 16 31.332 16C31.222 16 31.1147 15.9664 31.0245 15.9036C30.9342 15.8408 30.8653 15.7519 30.827 15.6488L29.1911 11.1422L24.6845 9.50358C24.5814 9.46532 24.4925 9.39643 24.4297 9.30617C24.367 9.21591 24.3333 9.1086 24.3333 8.99865C24.3333 8.88871 24.367 8.7814 24.4297 8.69114C24.4925 8.60088 24.5814 8.53199 24.6845 8.49373L29.1911 6.85778L30.8297 2.35117C30.868 2.24809 30.9369 2.1592 31.0271 2.09642C31.1174 2.03365 31.2247 2 31.3347 2C31.4446 2 31.5519 2.03365 31.6422 2.09642C31.7324 2.1592 31.8013 2.24809 31.8396 2.35117L33.4782 6.85778L37.9848 8.49642C38.0879 8.53468 38.1768 8.60357 38.2396 8.69383C38.3024 8.78409 38.336 8.8914 38.336 9.00135C38.336 9.11129 38.3024 9.2186 38.2396 9.30886C38.1768 9.39912 38.0879 9.46801 37.9848 9.50627L33.4755 11.1422Z",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlessedSeeker);
export default __webpack_public_path__ + "static/media/blessedSeeker.3e0a7e66e9d4c7403ed9e968dd3f3a5f.svg";
export { ForwardRef as ReactComponent };